import { uniqueId } from 'lodash';
import { useCallback, useState } from 'react';

const useRandom = (): [string, () => void] => {
	const [key, setKey] = useState(uniqueId());
	const onSetKey = useCallback(() => {
		setKey(uniqueId());
	}, [setKey]);
	return [key, onSetKey];
};

export default useRandom;
